(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["login_template"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const forgottenPassword =  (() => {
      const init = () => {
        const btn = document.querySelector('[data-forgotten-password-btn]');
        btn.addEventListener('click', handleBtnClick);
      };
      const handleBtnClick = () => {
        const container = document.querySelector('[data-forgotten-password]');
        container.classList.toggle('hidden');
      };
      return { init };
    })();
    forgottenPassword.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    let id = document.querySelector(".product_template").dataset.id;
    axios.get(`https://bart-ingredients.myshopify.com/admin/api/2022-01/products/${id}.json`)
    .then(function(response){
      console.log(response);
    });
    let filter_form_product = document.querySelector(".product-scroll-widget");
    if(filter_form_product != undefined && filter_form_product != null){
      document.addEventListener("scroll", () => {
        let top = (window.pageYOffset || document.scrollTop)  - (document.clientTop || 0);
        if(top > 900){
          filter_form_product.classList.add("stick");
        } else {
          filter_form_product.classList.remove("stick");
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
      })();
